var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPm10Yellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6891 45.0004C41.4799 45.0004 41.2699 44.9896 41.0607 44.9781C40.4547 44.9342 39.9909 44.4051 40.0356 43.7983C40.0794 43.1923 40.6085 42.7508 41.2153 42.7732C43.1334 42.9054 45.0085 42.2109 46.3642 40.8551C47.6209 39.6092 48.3046 37.9442 48.3046 36.1799C48.3046 34.4156 47.6209 32.7514 46.3642 31.5055C45.1068 30.2596 43.4533 29.5651 41.689 29.5651H8.61263C8.0066 29.5651 7.50977 29.069 7.50977 28.4622C7.50977 27.8562 8.00581 27.3594 8.61263 27.3594H41.689C44.0485 27.3594 46.2642 28.2746 47.9292 29.9395C49.5943 31.6046 50.5094 33.8203 50.5094 36.1797C50.5094 38.5392 49.5942 40.7549 47.9292 42.42C46.265 44.0742 44.0154 45.0001 41.689 45.0001L41.6891 45.0004Z",
    fill: "#FFF744",
    stroke: "#FFF744",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4098 24.0526H3.10286C2.49683 24.0526 2 23.5565 2 22.9497C2 22.3437 2.49605 21.8469 3.10286 21.8469H49.4098C54.2718 21.8469 58.2304 17.8885 58.2304 13.0263C58.2304 8.16426 54.272 4.20572 49.4098 4.20572C48.8038 4.20572 48.307 3.70968 48.307 3.10286C48.307 2.49684 48.803 2 49.4098 2C55.4846 2 60.4353 6.95063 60.4353 13.0255C60.4353 19.1019 55.4854 24.0525 49.4098 24.0525V24.0526Z",
    fill: "#FFF744",
    stroke: "#FFF744",
    strokeWidth: 2.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0163 17.4377C29.0163 18.3513 28.2757 19.0912 27.362 19.0912C26.4491 19.0912 25.7085 18.3513 25.7085 17.4377C25.7085 16.524 26.4491 15.7842 27.362 15.7842C28.2757 15.7842 29.0163 16.524 29.0163 17.4377Z",
    fill: "#FFF744"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0163 17.4377C29.0163 18.3513 28.2757 19.0912 27.362 19.0912C26.4491 19.0912 25.7085 18.3513 25.7085 17.4377C25.7085 16.524 26.4491 15.7842 27.362 15.7842C28.2757 15.7842 29.0163 16.524 29.0163 17.4377",
    stroke: "#FFF744"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9367 18.54C38.9367 19.4529 38.1961 20.1935 37.2832 20.1935C36.3695 20.1935 35.6289 19.4529 35.6289 18.54C35.6289 17.6264 36.3695 16.8857 37.2832 16.8857C38.1961 16.8857 38.9367 17.6264 38.9367 18.54Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0856 15.8976C49.0856 17.177 48.0476 18.215 46.7682 18.215C45.4877 18.215 44.4497 17.177 44.4497 15.8976C44.4497 14.6171 45.4877 13.5791 46.7682 13.5791C48.0476 13.5791 49.0856 14.6171 49.0856 15.8976Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6093 33.9748C24.6093 34.8885 23.8694 35.6283 22.9557 35.6283C22.0421 35.6283 21.3022 34.8885 21.3022 33.9748C21.3022 33.0611 22.0421 32.3213 22.9557 32.3213C23.8694 32.3213 24.6093 33.0611 24.6093 33.9748Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3185 35.0771C32.3185 35.99 31.5779 36.7306 30.6642 36.7306C29.7514 36.7306 29.0107 35.99 29.0107 35.0771C29.0107 34.1635 29.7514 33.4229 30.6642 33.4229C31.5779 33.4229 32.3185 34.1635 32.3185 35.0771Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1385 36.1818C41.1385 37.0955 40.3987 37.8361 39.485 37.8361C38.5714 37.8361 37.8315 37.0955 37.8315 36.1818C37.8315 35.2689 38.5714 34.5283 39.485 34.5283C40.3987 34.5283 41.1385 35.2689 41.1385 36.1818Z",
    fill: "#FFF744",
    stroke: "#FFF744",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6771 36.1818C57.6771 37.0955 56.9373 37.8361 56.0236 37.8361C55.11 37.8361 54.3701 37.0955 54.3701 36.1818C54.3701 35.2689 55.11 34.5283 56.0236 34.5283C56.9373 34.5283 57.6771 35.2689 57.6771 36.1818Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9079 40.5898C27.9079 41.5027 27.1673 42.2433 26.2544 42.2433C25.3407 42.2433 24.6001 41.5027 24.6001 40.5898C24.6001 39.6762 25.3407 38.9355 26.2544 38.9355C27.1673 38.9355 27.9079 39.6762 27.9079 40.5898Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4704 28.4641C55.4704 29.3777 54.7298 30.1176 53.8169 30.1176C52.9032 30.1176 52.1626 29.3777 52.1626 28.4641C52.1626 27.5504 52.9032 26.8105 53.8169 26.8105C54.7298 26.8105 55.4704 27.5504 55.4704 28.4641Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1869 27.3605C63.1869 28.2742 62.447 29.0148 61.5334 29.0148C60.6197 29.0148 59.8799 28.2742 59.8799 27.3605C59.8799 26.4476 60.6197 25.707 61.5334 25.707C62.447 25.707 63.1869 26.4476 63.1869 27.3605Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2477 9.72263C42.2477 10.6355 41.5071 11.3761 40.5942 11.3761C39.6806 11.3761 38.9399 10.6355 38.9399 9.72263C38.9399 8.80898 39.6806 8.06836 40.5942 8.06836C41.5071 8.06836 42.2477 8.80898 42.2477 9.72263Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6288 13.0273C35.6288 13.9402 34.8889 14.6808 33.9753 14.6808C33.0616 14.6808 32.3218 13.9402 32.3218 13.0273C32.3218 12.1137 33.0616 11.373 33.9753 11.373C34.8889 11.373 35.6288 12.1137 35.6288 13.0273Z",
    fill: "#FFF744",
    stroke: "#FFF744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm10Yellow);
export default __webpack_public_path__ + "static/media/PM10_Yellow.e40a45e9e5c0f63bbb78cb95f4cae8c2.svg";
export { ForwardRef as ReactComponent };